import { mapGetters } from 'vuex'
import SiteSearchGroup from '@/components/search-group'
import journal from '@/api/journal'
import Detail from './detail.dialog.vue'
import Reject from './reject.dialog.vue'
import { reviewerApply } from '@/api/reviewer'
import SendEmail from '@/views/editorial-office/manuscripts/dialog/send-email.dialog'
const columns = [
  {
    title: '',
    enTitle: 'Email',
    width: 150,
    dataIndex: 'email',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Name',
    width: 120,
    dataIndex: 'Name',
    slot: 'name'
  },
  {
    title: '',
    enTitle: 'Affiliations',
    width: 200,
    dataIndex: 'affiliation',
    slot: 'omis'
  },
  // {
  //   title: '',
  //   enTitle: 'Identity',
  //   width: 150,
  //   dataIndex: 'identityCode',
  //   slot: 'roles'
  // },
  {
    title: '',
    enTitle: 'Status',
    width: 100,
    dataIndex: 'handle',
    slot: 'status'
  },
  {
    title: '',
    enTitle: 'Operator',
    width: 120,
    dataIndex: 'operator',
    slot: 'operator'
  },
  {
    title: '',
    enTitle: 'Apply Time',
    width: 150,
    dataIndex: 'createTime',
    slot: 'date'
  },
  {
    title: '',
    enTitle: 'Processing Time',
    width: 150,
    dataIndex: 'dealTime',
    slot: 'date'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 170,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
export default {
  components: {
    SiteSearchGroup,
    Detail,
    Reject,
    SendEmail
  },
  data() {
    return {
      columns,
      isVisableDetail: false,
      showReason: false,
      showSendEmail: false,
      journalList: [],
      dataSource: [],
      inputData: {},
      params: {
        handle: '',
        journalId: '',
        handleList: ''
      },
      pagination: {
        total: 0,
        size: 10,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true
      },
      emailData: {},
      emailHandle: ''
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      domain: 'getDomain',
      user: 'getUser',
      country: 'getCountry'
    })
  },
  async mounted() {
    await this.getJournalList()
  },
  methods: {
    async getList(page = 1) {
      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: this.pagination.size
      })
      const { list, pageIndex, pageSize, total } = await reviewerApply.get(data)
      this.dataSource = list
      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })
    },
    async getJournalList() {
      this.journalList = await journal.userGet({ released: true })
      const flag = this.journalList.some(item => {
        if (item.id === localStorage.getItem('journalId')) {
          this.params.journalId = item.id
          return true
        }
      })
      if (!flag) {
        this.params.journalId = this.journalList[0] && this.journalList[0].id
        localStorage.setItem('journalId', this.params.journalId)
      }
      this.getList()
    },
    changeStatus(status) {
      this.params.handleList = status
      this.getList()
    },
    async able(val, handle) {
      const { id, version } = val
      await reviewerApply.accepted(
        id,
        Object.assign(val, {
          journalId: this.params.journalId,
          handle,
          version
        })
      )
      let content = `This Editorial Board has been ${handle.toLowerCase()}!`
      this.$message.success({
        title: 'Success',
        content: content
      })
      this.getList()
    },
    handleClear() {
      this.params.keyword = ''
      this.getList()
    },
    async accept(val, handle) {
      this.emailData = val
      this.emailHandle = handle
      if (handle === 'ACCEPTED') {
        this.$confirm({
          title: `Want to ${
            handle === 'ACCEPTED' ? 'accept' : 'reject'
          } this application?`,
          content: `Please be aware of once this application is ${handle.toLowerCase()}, the candidate will receive a notification email.`,
          type: handle === 'ACCEPTED' ? 'success' : 'danger',
          icon: handle === 'ACCEPTED' ? 'iconAble' : 'iconDetails',
          confirmText: handle === 'ACCEPTED' ? 'Accept' : 'Reject'
        }).then(async () => {
          // this.sendEmail(val)
          await reviewerApply.accepted(val.id, {
            handle,
            journalId: this.params.journalId
          })
          this.$message.success({
            title: 'Success',
            content: `The Reviewer Board has been ${handle.toLowerCase()}!`
          })
          this.getList()
        })
      } else {
        this.inputData = val
        this.showReason = true
      }
    },
    async rejectConfirm(reason, id) {
      this.showReason = false
      await reviewerApply.accepted(id, {
        journalId: this.params.journalId,
        handle: 'REFUSED',
        reason
      })
      this.$message.success({
        title: 'Success',
        content: `The Editoral Board has been declined!`
      })
      this.getList()
    },
    async detail(val) {
      this.isVisableDetail = true
      this.inputData = await reviewerApply.query(val.id, {
        journalId: this.params.journalId
      })
    },
    changeJournal(val) {
      this.getList()
      localStorage.setItem('journalId', val)
    },
    cancel() {
      this.isVisableDetail = false
      this.showReason = false
      this.showSendEmail = false
    },
    // 发送邮件
    sendEmail(val) {
      this.inputData = {
        applyReviewerId: val.id,
        journalId: this.params.journalId,
        journalIdList: val.journalList
          ? val.journalList
              .map(item => {
                return item.id
              })
              .join(',')
          : []
      }
      this.showSendEmail = true
    },
    async send() {
      await reviewerApply.accepted(this.emailData.id, {
        handle: this.emailHandle,
        journalId: this.params.journalId
      })
      this.$message.success({
        title: 'Success',
        content: `The Reviewer Board has been ${this.emailHandle.toLowerCase()}!`
      })
      this.cancel()
      this.getList()
    }
  }
}
